import { ENGAGEMENT_COLUMNS, FEEDBACK_COLUMNS } from '@/types/filterKeyConst';

import { RangeFilter } from '../components/RangeFilter';

export const useEngagementFilterMap = () => {
  const showVotesFilters = true;
  const getColumnName = (_columnKey: ENGAGEMENT_COLUMNS, fallback: string) =>
    fallback;

  const fieldOptions: StructuredFieldOptionMap = {
    [ENGAGEMENT_COLUMNS.VIEW_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.VIEW_COUNT,
      columnName: getColumnName(ENGAGEMENT_COLUMNS.VIEW_COUNT, 'View Count'),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.LIKE_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.LIKE_COUNT,
      columnName: getColumnName(ENGAGEMENT_COLUMNS.LIKE_COUNT, 'Like Count'),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.COMMENT_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.COMMENT_COUNT,
      columnName: getColumnName(
        ENGAGEMENT_COLUMNS.COMMENT_COUNT,
        'Comment Count',
      ),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.SHARE_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.SHARE_COUNT,
      columnName: getColumnName(ENGAGEMENT_COLUMNS.SHARE_COUNT, 'Share Count'),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },

    [ENGAGEMENT_COLUMNS.COLLECT_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.COLLECT_COUNT,
      columnName: getColumnName(
        ENGAGEMENT_COLUMNS.COLLECT_COUNT,
        'Collect Count',
      ),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.SUBSCRIBERS_COUNT]: {
      columnKey: ENGAGEMENT_COLUMNS.SUBSCRIBERS_COUNT,
      columnName: getColumnName(
        ENGAGEMENT_COLUMNS.SUBSCRIBERS_COUNT,
        'Subscribers Count',
      ),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.ENGAGEMENT_RATE]: {
      columnKey: ENGAGEMENT_COLUMNS.ENGAGEMENT_RATE,
      columnName: getColumnName(
        ENGAGEMENT_COLUMNS.ENGAGEMENT_RATE,
        'Engagement Rate',
      ),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    [ENGAGEMENT_COLUMNS.TOTAL_ENGAGEMENT]: {
      columnKey: ENGAGEMENT_COLUMNS.TOTAL_ENGAGEMENT,
      columnName: getColumnName(
        ENGAGEMENT_COLUMNS.TOTAL_ENGAGEMENT,
        'Engagement Total',
      ),
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
    ...(showVotesFilters
      ? {
          [ENGAGEMENT_COLUMNS.VOTES_DOWN_COUNT]: {
            columnKey: ENGAGEMENT_COLUMNS.VOTES_DOWN_COUNT,
            columnName: 'Votes Down Count',
            isMultiValueField: false,
            filterItemOptions: {
              type: 'range',
              RangeComponent: RangeFilter,
            },
          },
          [ENGAGEMENT_COLUMNS.VOTES_UP_COUNT]: {
            columnKey: ENGAGEMENT_COLUMNS.VOTES_UP_COUNT,
            columnName: 'Votes Up Count',
            isMultiValueField: false,
            filterItemOptions: {
              type: 'range',
              RangeComponent: RangeFilter,
            },
          },
        }
      : {}),
    [FEEDBACK_COLUMNS.IMPRESSION]: {
      columnKey: FEEDBACK_COLUMNS.IMPRESSION,
      columnName: 'Impression',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'range',
        RangeComponent: RangeFilter,
      },
    },
  };

  return fieldOptions;
};
